<script>
    import { FlowRouter } from "meteor/ostrio:flow-router-extra";

    let { vehicle } = $props();

    const fallbackImage = "/vehicles/cars.webp";

    function currency(value) {
        return new Intl.NumberFormat("en-CA", {
            style: "currency",
            currency: "CAD",
            maximumFractionDigits: 0,
        }).format(Number(value || 0));
    }

    const title = $derived(
        vehicle?.title ||
            [vehicle?.year, vehicle?.make, vehicle?.model]
                .filter(Boolean)
                .join(" ") ||
            "Vehicle",
    );
    const metaParts = $derived(
        [vehicle?.year, vehicle?.make, vehicle?.model].filter(Boolean),
    );
    const specParts = $derived(
        [
            vehicle?.mileage
                ? `${Number(vehicle.mileage).toLocaleString()} km`
                : null,
            vehicle?.transmission || null,
            vehicle?.condition || null,
        ].filter(Boolean),
    );

    function openDetails() {
        if (!vehicle?._id) return;
        FlowRouter.go(`/vehicles/${vehicle._id}`);
    }
</script>

<article class="inventory-card">
    <img
        src={vehicle?.photos?.[0]?.variants?.card || fallbackImage}
        alt={title}
    />
    <div class="card-content">
        <h3>{title}</h3>
        {#if metaParts.length > 0}
            <p class="meta">{metaParts.join(" ")}</p>
        {/if}
        {#if vehicle?.price !== undefined && vehicle?.price !== null && vehicle?.price !== ""}
            <p class="price">{currency(vehicle.price)}</p>
        {/if}
        {#if specParts.length > 0}
            <p class="specs">{specParts.join(" · ")}</p>
        {/if}
        <button type="button" class="card-link-btn" onclick={openDetails}
            >View Details</button
        >
    </div>
</article>
